<ng-container *ngIf="cardSourceArcs$ | async as cardSourceArcs; else sourceActions">
  <div class="source-arc-actions">
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      type="button"
      mat-raised-button
      (click)="addSourceArcHandler(cardSourceArcs[cardSourceArcs.length - 1])">
      {{ 'Aggiungi fonte' | translate }}
    </button>
  </div>
  <div [formGroup]="form">
    <ui-draggable-list
      *ngIf="cardSourceArcs.length > 0; else noItems"
      [items]="cardSourceArcs"
      (dropComplete)="orderSourceArcHandler($event)">
      <ng-template
        uiListItem
        let-arc="item"
        let-i="index">
        <div class="arc-container">
          <div
            *roleVisibility="['create', 'update']; classNames: classNames"
            class="arc-actions">
            <button
              mat-icon-button
              type="button"
              (click)="removeSourceArcHandler(arc, i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <div
            class="arc-row-container"
            [formArrayName]="i">
            <img
              *ngIf="arc?.docArc.previewUrl"
              class="arc-preview-img"
              loading="lazy"
              [src]="arc?.docArc.previewUrl">
            <div class="arc-info-details">
              <small class="arc-info">
                {{ 'Titolo' | translate }}: {{ arc?.docArc.titolo  }}
              </small>
              <small class="arc-info">
                {{ 'Descrizione' | translate }}: {{ arc?.docArc.descrizione }}
              </small>
              <small class="arc-info">
                {{ 'Tipo' | translate }}: {{ arc?.docArc.tipo }}
              </small>
            </div>
          </div>
          <div class="arc-navigate">
            <button
              mat-icon-button
              type="button"
              [routerLink]="['/archival-sources', 'manager', arc?.docArc.id ]">
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </ui-draggable-list>

    <ng-template #noItems>
      <ui-no-items [size]="40"></ui-no-items>
    </ng-template>
  </div>
</ng-container>

<ng-template #sourceActions>
  <div class="source-arc-actions">
    <button
      type="button"
      mat-raised-button
      (click)="addSourceArcHandler()">
      {{ 'Aggiungi fonte' | translate }}
    </button>
  </div>
</ng-template>
